import { axiosInstance } from "lib/axios";
import { authAPI, searchAPI } from "services/apis.service";
import { getDatabaseProviderName } from "utils/database-source.util";

export const getCollections = async (user) => {
  const { data } = await axiosInstance.post(
    searchAPI.getCollections,
    {
    },
    {
      cache: false,
    }
  );
  return data;
};

export const getrecentCollections = async (user) => {
  const { data } = await axiosInstance.post(
    searchAPI.getRecentCollections,
    {
    },
    {
      cache: false,
    }
  );
  return data;
};

export const getrecentCollectionSource = async (user) => {
  const { data } = await axiosInstance.post(
    searchAPI.getRecentCollectionSource,
    {
      filter: "",
      forBookmarkPanel: true,
    },
    {
      cache: false,
    }
  );
  return data;
};

export const getBookmarksFromCollection = async (user, id) => {
  const { data } = await axiosInstance.post(
    searchAPI.getCollectionsSource,
    {
      collectionId: id,
      forBookmarkPanel: true,
    },
    {
      cache: false,
    }
  );
  return data;
};

export const getParentChainCollection = async (id, user) => {
  const { data } = await axiosInstance.post(
    searchAPI.getParentChainCollection,
    {
      collectionId: id,
    },
    {
      cache: false,
    }
  );
  return data;
};

export const getSharedUserList = async (user, id) => {
  const { data } = await axiosInstance.post(
    searchAPI.sharedUserList,
    {
      collectionId: id,
    },
    { cache: false }
  );

  return data;
};

export const addUserToCollection = async (payload) => {
  await axiosInstance.post(searchAPI.shareCollections, payload, {
    cache: false,
  });
};

export const deleteSharedUser = async (id, user, userToRemove) => {
  const isDistributionList = userToRemove?.sharedWithTypeId === 2;

  const requestsData = {
    collectionId: id,
    sharedWithTypeId: userToRemove?.sharedWithTypeId || 1,
    ...(isDistributionList
      ? { distributionListId: userToRemove.distributionListId }
      : {
        sharedWithUserId: userToRemove.userId,
        sharedWithEmailId: userToRemove.email
      }
    ),
  };

  const res = await axiosInstance.post(
    searchAPI.removeSharedUser,
    requestsData,
    { cache: false }
  );
};

export const addUseToPublicCollection = async (user, id, isPublic) => {
  const requestsData = {
    collectionId: id,
    isPublic: isPublic,
  };
  const { data } = await axiosInstance.post(
    searchAPI.updateCollectionPublic,
    requestsData,
    { cache: false }
  );
  return data;
};

export const getPublicCollections = async (user) => {
  const { data } = await axiosInstance.post(
    searchAPI.getPublicCollections,
    {
    },
    {
      cache: false,
    }
  );
  return data;
};

export const getPublicCollectionsSource = async (user, id) => {
  const { data } = await axiosInstance.post(
    searchAPI.getPublicCollectionsSource,
    {
      publicCollectionId: id,
    },
    {
      cache: false,
    }
  );

  return data;
};

export const deleteCollection = async (user, id) => {
  await axiosInstance.delete(
    searchAPI.deleteCollections,
    {
      data: {
        collectionId: id,
        isHardDelete: false,
      },
    },
    {
      cache: false,
    }
  );
};

export const publicCollection = async (user, id, name) => {
  const requestsData = {
    collectionId: id,
    collectionName: name,
  };
  await axiosInstance.post(searchAPI.updateCollections, requestsData, {
    cache: false,
  });
};

export const saveCollectionFolderWithNotes = async (
  user,
  markdownNotes,
  id
) => {
  const requestsData = {
    note: markdownNotes,
    collectionId: id,
  };
  try {
    const { data } = await axiosInstance.post(
      searchAPI.updateCollections,
      requestsData,
      {
        cache: false,
      }
    );
    return data.collectionID_ids;
  } catch (error) {
    throw error;
  }
};

export const saveCollectionFolder = async (user, name, parent) => {
  const requestsData = {
    collectionName: name,
    ...parent,
  };
  const { data } = await axiosInstance.post(
    searchAPI.updateCollections,
    requestsData,
    {
      cache: false,
    }
  );
  return data.collectionID_ids;
};

export const saveCustomBookmark = async (json_res) => {
  const databaseProviderName = getDatabaseProviderName(json_res);
  const { data } = await axiosInstance.post(
    searchAPI.AddUpdateCollectionsSource,
    databaseProviderName != null ? { ...json_res, databaseProviderName } : json_res,
    {
      cache: false,
    }
  );

  return data.collectionSourceID_ids;
};

export const removeAllSharedUsers = async (id, user) => {
  const { data } = await axiosInstance.post(
    searchAPI.removeAllUsersFromSharedCollection,
    {
      collectionId: id,
    },
    { cache: false }
  );
};

export const getCollectionOverview = async (user, id, isArchived) => {
  const { data } = await axiosInstance.post(
    searchAPI.collectionOverView,
    {
      collectionId: id,
      ...(isArchived && { isArchivedRequired: true }),
    },
    {
      cache: false,
    }
  );

  return data;
};

export const getPublicCollectionOverview = async (user, id) => {
  const { data } = await axiosInstance.post(
    searchAPI.publicCollectionOverView,
    {
      publicCollectionId: id,
    },
    {
      cache: false,
    }
  );

  return data;
};

export const copyCollection = async (id) => {
  const { data } = await axiosInstance.post(
    searchAPI.copyCollection,
    {
      collectionId: id,
    },
    {
      cache: false,
    }
  );
  return data;
};

export const archiveCollection = async (id, isArchived) => {
  const { data } = await axiosInstance.post(
    searchAPI.archiveCollection,
    {
      collectionId: id,
      isArchived: isArchived,
    },
    {
      cache: false,
    }
  );
  return data;
};

export const getArchivedCollections = async () => {
  const { data } = await axiosInstance.get(
    searchAPI.getArchivedCollections,
    {
      cache: false,
    }
  );
  return data;
};

export const followUnFollowUser = async (user, id, username) => {
  const { data } = axiosInstance.post(
    authAPI.followUnFollowUser,
    {
      followerUserId: id,
      followingUserName: username,
      followAction: true,
    },
    {
      cache: false,
    }
  );

  return data;
};
